<template>
  <!--首页分类card组件-->
  <card :height="100" class="class-card">
    <tk-flex column>
      <!--标题行-->
      <card-title
        :type="type"
        :title="title"
        :commodity-arr="commodityArr"
        :is-more="true"
        :font-size="16"
        :linear-top-color="'#fff'"
        :linear-bottom-color="'#fff'"
      >
        <tk-flex
          middle
          v-if="type === 'limitedTimeSnapping'
           && commodityArr.length && timeData"
          class="font-12 m-l-10 class-card-time"
        >
          <div class="class-card-time-lt">{{timeData.startTime | limitedTimeMount}}至</div>
          <div class="class-card-time-rt">{{timeData.endTime | limitedTimeMount}}</div>
        </tk-flex>
      </card-title>
      <!--列表行-->
      <tk-scroller
        :direction="'x'"
        style="width: 100%;"
        v-if="commodityArr.length"
      >
        <tk-flex gutter="5">
          <tk-flex
            column
            center
            :class="{'class-card-projection': type === 'newProducts'}"
            v-for="(s, index) in commodityArr"
            @click.native="$push({ path: '/commodity/productDetails', query: { id: s.objectId } })"
            :key="index"
          >
            <div class="class-recommended-img" style="width: 105px;">
              <tk-image class="img-radius class-recommended-image" :src="s.showPictures[0]" width="108" height="108"></tk-image>
            </div>
            <div v-if="type === 'limitedTimeSnapping'">
              <div class="font-12 class-card-red m-t-2">抢购价 <span class="font-14"><span class="font-10">￥</span>{{s.price}}</span></div>
              <!--<div class="font-14 class-card-decoration caption m-t-2"><span class="font-10">￥</span>{{s.oldPrice}}</div>-->
            </div>
            <div v-else-if="type === 'newProducts'"
                     style="text-align: center"
                     class="font-14 class-card-black m-t-2
                     class-card-wrap van-ellipsis">{{s.productTitle}}</div>
            <tk-flex column v-else>
              <div class="font-14 class-card-black
               class-card-wrap van-ellipsis van-ellipsis m-t-2">{{s.productTitle}}</div>
              <div v-if="s.oldPrice">
                <div class="class-card-red m-t-2">
                  <span class="font-10">￥</span>{{s.price}}
                  <span class="font-12 m-l-5 class-card-decoration caption">
                    <span class="font-10">￥</span>{{s.oldPrice}}</span>
                </div>
              </div>
              <div v-else class="class-card-red m-t-2"><span class="font-10">￥</span>{{ s.price}}</div>
            </tk-flex>
          </tk-flex>
        </tk-flex>
      </tk-scroller>
      <empty-tips v-else :height="100" :width="100" :empty-msg="'暂无数据'"></empty-tips>
    </tk-flex>
  </card>
</template>

<script>
import card from '@/components/card'
import cardTitle from '@/components/cardTitle'
export default {
  components: {
    card,
    cardTitle
  },
  props: {
    title: {
      type: String,
      required: true
    },
    timeData: {
      type: Object
    },
    type: {
      type: String,
      required: true
    },
    commodityArr: {
      type: Array,
      required: true
    }
  },
  computed: {
    // 账号类别
    category () {
      return this.$store.state.user.accountCategory
    }
  }
}
</script>

<style scoped lang="scss">
  .class-card {
    padding: 8px 12px !important;
  }
  /*限时抢购时间样式*/
  .class-card-time {
    width: 120px;
    height: 20px;
    border: 1px solid rgba(229, 4, 0, 1);
    border-radius: 10px;
    .class-card-time-lt {
      background: rgba(229, 4, 0, 1);
      width: 60px;
      height: 20px;
      line-height: 21px;
      text-align: center;
      color: #fff;
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
    }
    .class-card-time-rt {
      width: 60px;
      height: 20px;
      line-height: 21px;
      text-align: center;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
      color: rgba(229, 4, 0, 1);
    }
  }
  /*颜色及文本修饰*/
  .class-card-red {
    color: rgba(250, 51, 51, 1);
  }
  .class-card-black {
    width: 105px;
    color: #000000;
  }
  /*新品上市投影*/
  .class-card-projection {
    border-radius: 10px;
  }
</style>
